<template>
  <div class="bx_footer">
    <div class="bx_footer_content">
      <div class="bx_footer_container">
        <div class="footer_logo">
          <img
            class="logo"
            src="@/assets/images/version/logo2.png"
            alt="骆驼规划"
          />
          <div class="slogan">省心省钱买对保险</div>
        </div>
        <div class="footer_contact_info">
          <div class="qrcode clearfix">
            <img v-if="qrcode" :src="qrcode" alt="骆驼讲保公众号二维码" />
            <p>关注骆驼讲保公众号</p>
          </div>
          <div class="contact">
            <p>客服电话：400-099-9559</p>
            <p>电子邮箱：service@luotuoguihua.com</p>
          </div>
        </div>
      </div>
      <div class="line"></div>

      <div class="cpoyright">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36010202000252"
          class="beian-1"
          rel="nofollow"
        >
          <img class="beian-img" src="@/assets/images/beian.png" alt="" />
          赣公网安备36010202000252号
        </a>
        <a
          target="_blank"
          href="http://beian.miit.gov.cn/"
          class="beian"
          rel="nofollow"
        >
          {{ copyright }}
        </a>
        <span class="power">
          版权所有 © 2020 润安国际保险经纪有限公司
        </span>
        <span class="footer_link">
          <!-- <router-link :to="{ path: '/tagsmap' }"
						>标签地图</router-link
					>-<router-link :to="{ path: '/sitemap' }"
						>网站地图</router-link
					>- -->
          <router-link :to="{ path: '/about/41' }">关于我们</router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    hideMap: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      copyright: ""
    };
  },
  computed: {
    qrcode() {
      let url = require("@/assets/images/versionNew/qrcode_new.jpg");
      // switch (this.type) {
      // 	case 1:
      // 		url = require('@/assets/images/qrcodes/home_bottom.jpg');
      // 		break;
      // 	case 2:
      // 		url = require('@/assets/images/qrcodes/consult_bottom.jpg');
      // 		break;
      // 	case 31:
      // 	case 51:
      //       case 52:
      //       case 53:
      //       case 54:
      //       case 55:
      //       case 57:
      //       case 58:
      //       case 59:
      //       case 65:
      // 		url = require('@/assets/images/qrcodes/information_bottom31.jpg');
      // 		break;
      // 	case 32:
      // 		url = require('@/assets/images/qrcodes/information_bottom32.jpg');
      // 		break;
      // 	case 33:
      // 		url = require('@/assets/images/qrcodes/information_bottom33.jpg');
      // 		break;
      // 	case 41:
      // 		url = require('@/assets/images/qrcodes/about_bottom41.jpg');
      // 		break;
      // 	case 42:
      // 		url = require('@/assets/images/qrcodes/about_bottom42.jpg');
      // 		break;
      // 	case 43:
      // 		url = require('@/assets/images/qrcodes/about_bottom43.jpg');
      // 		break;
      // 	case 5:
      // 		url = require('@/assets/images/qrcodes/tagsmap_bottom.jpg');
      // 		break;
      // 	case 6:
      // 		url = require('@/assets/images/qrcodes/sitemap_bottom.jpg');
      // 		break;
      // 	case 99:
      // 		url = this.$store.state.bottomQrcode;
      // 		break;
      // }
      return url;
    }
  },
  mounted() {
    if (window.location.host.indexOf("luotuoguihua") > 0) {
      this.copyright = "赣ICP备17002302号-4";
    }
    else if (window.location.host.indexOf("luotuobaoxian") > 0) {
      this.copyright = "赣ICP备17002302号-7";
    }
    else {
      this.copyright = "赣ICP备17002302号-9";
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  min-width: 1200px;
  background: #2b3854;
  height: 386px;
  .footer-content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0 80px;
  }
  .qrcode {
    display: flex;
    // justify-content: space-around;
  }
  .qrcode-info {
    width: 120px;
    text-align: center;
    color: #fff;
    line-height: 40px;
    margin: 80px 0 0 35px;
    img {
      width: 120px;
    }
  }

  .contact-info {
    margin-top: 40px;
    transform: translateX(-100px);
    .p1 {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 28px;
    }

    .p2 {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 22px;
      margin-top: 5px;
    }
  }
}
</style>
